import * as React from "react";
import { Row, Col, Modal } from "antd";
import { useState, useContext } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import Form, { FormComponentProps } from "antd/lib/form";
import StandardButton from "src/components/common/StandardButton/StandardButton";
import FormItem from "antd/lib/form/FormItem";

import { IVendaProps } from "src/services/interfaces/IVendaProps";
import { ServiceContext } from "src/services/provider/Service.provider";
import "./bank-info.scss";
import { ShowNotification } from "src/components/common/ShowNotification/ShowNotification";
import { TradePhaseEnum } from "src/services/interfaces/trade/TradePhaseEnum";
import { IBankOwner } from "src/services/interfaces/trade/tradeOwner/IBankOwner";
import { TradeAccountTypeEnum } from "src/components/common/BankInfo/TradeAccountTypeEnum";
import { SelectBankName } from 'src/components/common/SelectBankName/SelectBankName';
import { PbrInputNumbers } from 'src/components/common/PbrInputNumbers/PbrInputNumbers';

interface IBankInfo extends FormComponentProps {
  isRequired?: boolean;
}

function BankInfo(props: RouteComponentProps<any> & FormComponentProps & IVendaProps & IBankInfo) {
  const { tradeService } = useContext(ServiceContext);

  const { trade } = props;

  const [bankData, setBankData] = useState<IBankOwner>(props.trade.tradeOwner?.bankData);
  const [loading, setLoading] = useState(false);
  const [confirmationModalVisible, setConfirmationModalVisible] = useState(false);

  const handleSubmit = () => {
    props.form.validateFieldsAndScroll({ scroll: { offsetTop: 150 } }, async errs => {
      setConfirmationModalVisible(false);
      if (!errs) {
        setLoading(true);
        trade.tradeOwner = {
          ...trade.tradeOwner,
          bankData
        };
        tradeService
          .putBankingChannelByTradeId(trade.id, trade)
          .then((response) => {
            ShowNotification.Success("Sucesso!", response?.data?.message)
            props.onChangePhase(TradePhaseEnum.LegalCertificates);
          })
          .catch(ex => {
            ShowNotification.Error("Não é possivel atualizar o trade", ex?.response?.data?.message)
          })
          .finally(() => setLoading(false));
      }
    });
  };

  // XISTO: criar um handle para todas as properties do BankData

  return (
    <div className="bank-info steps-container">
      <h1>Dados bancários</h1>
      <Row style={{ margin: "0 auto  30px", fontWeight: "normal", fontSize: "15px", textTransform: "uppercase" }}>
        <Col xs={8} sm={8} md={8} lg={8}>
          <span style={{ color: "lightgrey" }}>1 - Dados pessoais</span>
        </Col>
        <Col xs={8} sm={8} md={8} lg={8}>
          <span style={{ fontWeight: "bold" }}>2 - Dados bancários</span>
        </Col>
      </Row>

      <p>
        Para programarmos o depósito, <strong>informe os dados bancários:</strong>
      </p>

      {trade && (
        <div className="form-container">
          <Form>
            <SelectBankName bankData={trade.tradeOwner?.bankData} onChange={e => setBankData({ ...bankData, bank: e })} form={props.form} isBankRequired={props.isRequired} />

            <PbrInputNumbers
              name="agency"
              value={bankData?.agency}
              title="Número da Agência (sem dígito)"
              formWrapper={props.form}
              rules={[
                { required: props.isRequired, message: "A agência é obrigatório" },
                { min: 4, max: 5, message: "A agência deve ter 4 a 5 dígitos" }]}
              onChange={agency => setBankData({ ...bankData, agency })}
            />

            <FormItem required colon={false}>
              <Row gutter={16} className="account-tipe-row">
                <Col sm={24} md={12} xl={12}>
                  <StandardButton
                    className={`${bankData.accountType === TradeAccountTypeEnum.Corrente ? "selected" : ""}`}
                    preset="outline"
                    onClick={() => setBankData({ ...bankData, accountType: TradeAccountTypeEnum.Corrente })}
                  >
                    Corrente
                  </StandardButton>
                </Col>
                <Col sm={24} md={12} xl={12}>
                  <StandardButton
                    className={`${bankData.accountType === TradeAccountTypeEnum.Poupanca ? "selected" : ""}`}
                    preset="outline"
                    onClick={() => setBankData({ ...bankData, accountType: TradeAccountTypeEnum.Poupanca })}
                  >
                    Poupança
                  </StandardButton>
                </Col>
              </Row>
            </FormItem>

            <PbrInputNumbers
              name="account"
              value={bankData?.account}
              title="Número da conta"
              formWrapper={props.form}
              rules={[{ required: props.isRequired, message: "A conta é obrigatória" }]}
              onChange={account => setBankData({ ...bankData, account })}
            />
            <PbrInputNumbers
              name="accountDigit"
              value={bankData?.accountDigit}
              title="Dígito da conta"
              formWrapper={props.form}
              rules={[
                { required: props.isRequired, message: "O dígito é obrigatório" },
                { max: 2, message: "O dígito da conta não deve ser maior que 2 dígitos" }
              ]}
              onChange={accountDigit => setBankData({ ...bankData, accountDigit })}
            />

            <span style={{ fontSize: "15px", fontWeight: "bold" }}>* É obrigatório que o titular da conta seja o titular do Precatório.</span>
            <Row className="actions-btn-row">
              <Col sm={24} md={6} lg={6} xl={6}>
                <StandardButton preset="outline" onClick={() => props.onChangePhase(TradePhaseEnum.ContractInformation)}>
                  Voltar
                </StandardButton>
              </Col>
              <Col sm={24} md={18} lg={18} xl={18}>
                <StandardButton onClick={() => setConfirmationModalVisible(true)} loading={loading}>
                  Continuar
                </StandardButton>
              </Col>
            </Row>
          </Form>
        </div>
      )}
      <Modal
        title="Confirmação de mudança de fase"
        visible={confirmationModalVisible}
        onCancel={() => setConfirmationModalVisible(false)}
        onOk={handleSubmit}
        className="modal-small"
        centered
      >
        <b>Tem certeza que deseja prosseguir para a próxima fase?</b>
        <p>Só é possível solicitar uma proposta de cobertura da concorrência na fase de "Dados para contrato". Se houver alguma proposta ativa a mesma será rejeitada automaticamente, <b>mantendo a precificação atual.</b></p>
      </Modal>
    </div>
  );
}

export default withRouter(Form.create()(BankInfo));



// WEBPACK FOOTER //
// ./src/pages/step-flow/steps/bank-info/BankInfo.tsx